export default {"src":"/_next/static/media/add-plus-green.40cd3c0c.svg","height":24,"width":24};